import 'ui-core/components/coolbar/js/coolbar';

UX.coolbar.vPort = 'screen-md';

UX.coolbar.control = function () {
    if ($('.journal-home').length) {
        UX.coolbar.vPort = 'screen-md';
    }

    $(document).on(UX.coolbar.vPort + '-on', function () {
        // Waiting for custom event that will be triggered by controller.js to activate responsive effects

        if (UX.coolbar.isStickyBar) {
            //$('.coolBar').addClass("fixed-element");
        } else {
            $('.coolBar').addClass('coolBar--res'); // class will be used in our scss (to replace media queries)
            UX.coolbar.headerHeight = $('header').outerHeight() || 0;
            $('.coolBar--res').addClass('trans').css('top', UX.coolbar.headerHeight);

            setTimeout(function () {
                $(document).trigger('eventSetContentPadding');
            }, 500);
            UX.coolbar.isMobile = true;

            if ($('.stickybar.coolBar--res').length > 0) {
                $('.content>article.container').addClass('article--res');
            }
        }
    });

    $(document).on(UX.coolbar.vPort + '-off', function () {
        // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
        $('.coolBar').removeClass('coolBar--res');
        $('.coolBar').removeClass('fixed-element');
        $('.content article.container').removeClass('article--res');
        $(document).trigger('eventSetContentPadding');
        UX.coolbar.isMobile = false;
        if (typeof UX.controller !== 'undefined') {
            UX.controller.check();
        }
    });
};
